<app-view-title Title="{{ 'Intellitrailer.Booking.Components.BookingSummary.Trailer' | translate : 'Trailer'}}: {{ booking?.RentalObject?.Alias ? booking?.RentalObject?.Title + ' - ' + booking?.RentalObject?.Alias : booking?.RentalObject?.Title }}" [isSoftSplit]="true">
</app-view-title>

<view-content [centered]="true" [fullscreen]="true">
  @if (!hasFailed) {
  <app-card>
    <h2>{{ 'Intellitrailer.Rental.IglooLock.IglooUnlock' | translate : 'Unlock' }}</h2>
    <img class="lock-keypad-image" src="/Images/igloohome-padlock-2.png" />

    @if (!isUnlockPin) {
    <p>
      {{ 'Intellitrailer.Rental.IglooLock.IglooUnlockWaiting' | translate : 'Please wait while we generate the unlock pin' }}...
    </p>
    } @else {
    <p>
      {{ 'Intellitrailer.Rental.IglooLock.IglooUnlockInfo1' | translate : 'Please enter the below pin to unlock.' }}
    </p>

    <div class="unlock-pin">
      <div *ngFor="let pin of unlockPin.split(''); let i = index">
        <span>{{ pin | transliterate  }}</span>
        @if (((i + 1) % 3 === 0) && (i !== unlockPin.length - 1)) {
        <span class="space"> </span>
        }
      </div>
      <span><mat-icon>lock_open</mat-icon></span>
    </div>

    <a (click)="troubleshootIglooLock()" class="link">
      {{ 'Intellitrailer.Rental.IglooLock.TitleLockNotOpen' | translate : 'Did the lock not open?' }}
    </a>
    }
  </app-card>
  } @else {
  <app-card>
    <app-information-screen [title]="failReason == 0
                                      ? ('Intellitrailer.Rental.IglooLock.IglooPinNotGenerated' | translate : 'Could not find the pin to unlock')
                                      : ('Intellitrailer.Rental.IglooLock.TitleLockNotOpen' | translate : 'Did the lock not open?')"
                            primaryContent="{{ 'Intellitrailer.Rental.IglooLock.IglooNotFoundInfo2' | translate : 'Please make sure you are at the correct trailer.' }}"
                            secondaryContent="{{ 'Intellitrailer.Rental.IglooLock.IglooNotFoundInfo1' | translate : 'Verify the lock number provided below with the trailer lock to ensure you are at the correct trailer.' }}">
    </app-information-screen>

    <p>
      <b>{{ 'Intellitrailer.Rental.IglooLock.Igloo.NotFoundLockNo' | translate : 'Lock'}}: {{ iglooLock }}</b>
    </p>
  </app-card>
  }
</view-content>

<view-actions mode="white">
  @if (event != 'Active' && hasFailed) {
  <button mat-raised-button color="accent" (click)="skip()">
    {{ 'Intellitrailer.Rental.IglooLock.cmdSkip' | translate : 'Skip' }}
  </button>
  <button mat-raised-button (click)="retry()">
    {{ 'Intellitrailer.Rental.IglooLock.Retry' | translate : 'Retry' }}
  </button>
  }
  @else {
  <button mat-raised-button (click)="continueIgloo()">
    {{ 'Intellitrailer.Rental.IglooLock.ContinueIgloo' | translate : 'Continue' }}
  </button>
  }

</view-actions>
